import React, { FC, useState } from 'react'
import { useZonesList } from 'modulesCommon/serviceHooks'
import { useCurrentUser } from 'modules/User/useCurrentUser'
import styles from './UserBanner.module.scss'

type TUserBannerProps = {}

export const DEV__UserBanner: FC<TUserBannerProps> = (props) => {
  const { user } = useCurrentUser()
  const { zoneList } = useZonesList()
  const [isShown, setIsShown] = useState(true)
  return ['dev', 'uat'].includes(process.env.REACT_APP_STAGE as string) && isShown? (
    <div className={styles.banner} onClick={() => setIsShown(false)}>
      <div>{user?.role?.role_id}</div>
      <div>{user?.email}</div>
      <div>{user?.is_external ? 'External' : 'Internal'}</div>
      <div>zone: {zoneList.find(z => z.id === user?.label_id)?.name ?? 'none'}</div>
    </div>
  ) : null
}
